module.exports = __webpack_public_path__ + "img/manufacturing-red.18dba1d9.png";